import React from 'react';
import Button from 'views/components/Button';
import CheckCircleIcon from 'views/components/icons/CheckCircle';
import WarningIcon from 'views/components/icons/Warning';

const CompletionCard = ({ endSelection = false, onBack }) => (
  <section className="completion-card information">
    {endSelection ? (
      <>
        <WarningIcon width={40} height={40} viewBox="0 0 23 20" />
        <h1>Assessment Not Available</h1>
        <p>
          This application is designed specifically for enterprise organizations. Based on your responses, this assessment may not provide the most relevant
          insights for your organization type.
        </p>
        <p>For questions about Equinix services tailored to your specific needs, please visit our website or contact our sales team.</p>
        {onBack && <Button text="Go Back" color="gray" isInverse onClick={onBack} />}
      </>
    ) : (
      <>
        <CheckCircleIcon width={40} height={40} viewBox="0 0 23 20" />
        <h1>Check Your Email</h1>
        <p className="completion-card__subtitle">Your personalized Connectivity Advisor is on the way.</p>
        <p>
          We&apos;re generating your tailored recommendations now.
          <br />
          Look for an email in the next few minutes with a link to view your custom report.
          <br />
          If you don&apos;t see it soon, please check your spam or email quarantine folder.
          <br />
          The message will come from our WorkBench platform.
        </p>
      </>
    )}
  </section>
);

export default CompletionCard;
